export default "__VITE_ASSET__CoVPzt6E__"